export enum ERolesEnum {
    admin = 'admin',
    user = 'user',
    manager = 'manager'
}

export enum ERolesPageEnum {
    owner = 'owner',
    guest = 'guest'
}

export enum EProfileType {
    'User',
    'Relative'
}
